import { render, staticRenderFns } from "./hizliSatisDepo.vue?vue&type=template&id=5808d03b"
import script from "./hizliSatisDepo.vue?vue&type=script&lang=js"
export * from "./hizliSatisDepo.vue?vue&type=script&lang=js"
import style0 from "./hizliSatisDepo.vue?vue&type=style&index=0&id=5808d03b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports